// src/api/solution.js
import request from '@/utils/request'

/**
 * 获取热门行业（按 sortOrder 降序取前N个）
 * @param {number} limit 数量，默认5
 */
export const getHotIndustries = (limit = 5) => {
  return request({
    url: '/api/solutions/hot-industries',
    method: 'get',
    params: { limit }
  })
}

/**
 * 获取所有行业列表
 * @returns {Promise} 行业列表
 */
export const getIndustries = () => {
  return request({
    url: '/api/solutions/industries',
    method: 'get'
  })
}



/**
 * 根据ID获取解决方案详情
 * @param {string|number} id 方案ID
 * @returns {Promise} 方案详情数据
 */
export const getSolutionById = (id) => {
  return request({
    url: `/api/solutions/${id}`,
    method: 'get'
  })
}



/**
 * 分页获取解决方案列表
 * @param {Object} params 查询参数
 * @param {number} params.current 当前页码
 * @param {number} params.size 每页数量
 * @param {string} [params.keyword] 搜索关键词
 * @param {number} [params.industryIds] 行业ID（单选）
 * @returns {Promise} 分页数据
 */
export const getSolutionsPage = (params) => {
  return request({
    url: '/api/solutions/page',
    method: 'get',
    params
  })
}